/* Horizontal sibling category chips — mobile scroll arrows when overflowing */

class CollectionMenuLinks extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-cl-list]');
    this.prevBtn = this.querySelector('[data-cl-prev]');
    this.nextBtn = this.querySelector('[data-cl-next]');
    if (!this.list) return;

    this._onScroll = () => this._update();
    this.list.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onScroll);

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this._scrollBy(-1));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this._scrollBy(1));
    }

    // Wait a frame so layout/fonts settle before measuring overflow
    requestAnimationFrame(() => this._update());
  }

  disconnectedCallback() {
    if (this.list && this._onScroll) {
      this.list.removeEventListener('scroll', this._onScroll);
    }
    if (this._onScroll) {
      window.removeEventListener('resize', this._onScroll);
    }
  }

  _scrollBy(direction) {
    const amount = Math.max(120, Math.floor(this.list.clientWidth * 0.7));
    this.list.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }

  _update() {
    if (!this.list) return;

    const { scrollLeft, scrollWidth, clientWidth } = this.list;
    const canScroll = scrollWidth > clientWidth + 2;
    const atStart = scrollLeft <= 2;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 2;

    this.classList.toggle('is-scrollable', canScroll);
    this.classList.toggle('is-at-start', atStart || !canScroll);
    this.classList.toggle('is-at-end', atEnd || !canScroll);

    if (this.prevBtn) {
      this.prevBtn.hidden = !canScroll || atStart;
    }
    if (this.nextBtn) {
      this.nextBtn.hidden = !canScroll || atEnd;
    }
  }
}

if (!customElements.get('collection-menu-links')) {
  customElements.define('collection-menu-links', CollectionMenuLinks);
}
